import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 bg-white z-50 shadow-[0_2px_10px_rgba(0,0,0,0.05)] px-5 md:px-[5%] py-2.5 flex items-center justify-between" data-id="element-64">
      <div className="flex-shrink-0" data-id="element-65">
        <a href="#inicio" aria-label="Inicio" data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/sE5R12pH22Hv8FHAbSJwEM/logo.png" alt="Vínculos de Vida" className="h-[60px] w-auto object-contain" data-id="element-67" />
        </a>
      </div>

      <a href="#contacto" className="bg-verde-oscuro text-white px-5 py-2.5 rounded-md no-underline font-bold text-sm transition-colors hover:bg-verde-vida focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-verde-principal" data-id="element-68">
        CONSULTAR RESERVA
      </a>
    </nav>;
}